import { CircleCheck, Copy } from "lucide-react";
import { useState } from "react";
import { Alert, Button, Col, Container, Fade, Row } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

import CompleteForm from "./components/moveInventory/CompleteForm";
import CreateRackItemModal from "./components/moveInventory/CreateRackItemModal";
import CreateRackModal from "./components/moveInventory/CreateRackModal";
import SummaryCard from "./components/moveInventory/SummaryCard";

const MoveInventoryPage = () => {
  const [summary, setSummary] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showRackItemModal, setShowRackItemModal] = useState(false);
  const [createRackResult, setCreateRackResult] = useState(null);
  const [createRackItemResult, setCreateRackItemResult] = useState(null);

  return (
    <>
      <Helmet title="Move Inventory" />
      <h3 className="d-sm-block">Move Inventory</h3>
      <Container fluid className="p-0">
        <Row>
          <Col xl={4}>
            <div className="d-flex justify-content-start">
              <Button
                variant="outline-primary"
                className="mb-3 me-3"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Create New Rack
              </Button>
              <Button
                variant="outline-primary"
                className="mb-3"
                onClick={() => {
                  setShowRackItemModal(true);
                }}
              >
                Create New Rack Item
              </Button>
            </div>
            {createRackResult && (
              <Alert variant="success" className="flex-fill alert-blink mb-3">
                <div className="alert-icon">
                  <CircleCheck
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message font-weight-bold">
                  <p>{createRackResult.message}</p>

                  <div className="d-flex align-items-center mb-1">
                    <span className="me-2">Rack ID:</span>

                    <strong className="me-2">
                      {createRackResult.newShipmentRack.shipmentRackId}
                    </strong>

                    <CopyToClipboard
                      text={createRackResult.newShipmentRack.shipmentRackId}
                      onCopy={() => {
                        toast.success(
                          `"${createRackResult.newShipmentRack.shipmentRackId}" copied to clipboard`
                        );
                      }}
                    >
                      <Button variant="outline-secondary" size="sm">
                        <Copy size={16} />
                      </Button>
                    </CopyToClipboard>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Listing Account:</span>
                    <strong>
                      {createRackResult.newShipmentRack.listingAccount || "N/A"}
                    </strong>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Shipment Category:</span>
                    <strong>
                      {createRackResult.newShipmentRack.shipmentCategory ||
                        "N/A"}
                    </strong>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Status:</span>
                    <strong>
                      {createRackResult.newShipmentRack.shipmentRackStatus}
                    </strong>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Last Updated:</span>
                    <strong>
                      {new Date(
                        createRackResult.newShipmentRack.lastUpdated
                      ).toLocaleString()}
                    </strong>
                  </div>
                </div>
              </Alert>
            )}

            {createRackItemResult && (
              <Alert variant="success" className="flex-fill alert-blink">
                <div className="alert-icon">
                  <CircleCheck
                    className="position-relative top-50 start-50 translate-middle"
                    size={20}
                  />
                </div>
                <div className="alert-message font-weight-bold">
                  <p>{createRackItemResult.message}</p>

                  <div className="d-flex align-items-center mb-1">
                    <span className="me-2">Rack Item ID:</span>

                    <strong className="me-2">
                      {
                        createRackItemResult.newShipmentRackItem
                          .shipmentRackItemId
                      }
                    </strong>

                    <CopyToClipboard
                      text={
                        createRackItemResult.newShipmentRackItem
                          .shipmentRackItemId
                      }
                      onCopy={() => {
                        toast.success(
                          `"${createRackItemResult.newShipmentRackItem.shipmentRackItemId}" copied to clipboard`
                        );
                      }}
                    >
                      <Button variant="outline-secondary" size="sm">
                        <Copy size={16} />
                      </Button>
                    </CopyToClipboard>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Rack ID:</span>
                    <strong>
                      {createRackItemResult.newShipmentRackItem.shipmentRackId}
                    </strong>
                  </div>

                  <div className="mb-1">
                    <span className="me-2">Created At:</span>
                    <strong>
                      {new Date(
                        createRackItemResult.newShipmentRackItem.createdAt
                      ).toLocaleString()}
                    </strong>
                  </div>
                </div>
              </Alert>
            )}
          </Col>
          <Col xl={4}>
            <CompleteForm setSummary={setSummary} />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xl={4}>
            <Fade in={Boolean(summary)}>
              <div>
                <SummaryCard summary={summary} />
              </div>
            </Fade>
          </Col>
        </Row>
      </Container>
      <CreateRackModal
        showModal={showModal}
        setShowModal={setShowModal}
        setCreateRackResult={setCreateRackResult}
      />
      `
      <CreateRackItemModal
        showRackItemModal={showRackItemModal}
        setShowRackItemModal={setShowRackItemModal}
        setCreateRackItemResult={setCreateRackItemResult}
      />
      `
    </>
  );
};

export default MoveInventoryPage;
